export default __webpack_public_path__ + "static/19_31-12e5f52a046d0b2726643bdbbfd7b30e.png";